export default "__VITE_ASSET__CMht$NC7__"